import {MarksHelper} from '../../../../app/shared/components/single-message-editor/code-mirror-wrapper/marks-helper';
import twitterText from 'twitter-text';
import punycode from 'punycode';

export class CharactersCounter {

  constructor(editor, $scope) {
    this.editor = editor;
    this.$scope = $scope; // scope of the <codemirror-and-toolbar> directive
    this.mark = null;
    this.maxCharsNumber = $scope.options.maxCharsNumber;
    this.useTwitterTextLib = $scope.options.useTwitterTextLib;
    editor.on('change', () => this.updateCharactersCountAndMark());
    $scope.$watch('addDMLink.isChecked', () => this.updateCharactersCountAndMark());
  }

  /**
   * Counts the number of remaining characters allowed, using ucs2 conversion,
   * and updates the mark of extra chars if necessary
   */
  updateNotTwitterCharactersCountAndMark(editorText) {
    const editorTextCPs = punycode.ucs2.decode(editorText);
    this.$scope.remainingCharacters = this.maxCharsNumber - editorTextCPs.length;
    if (this.$scope.remainingCharacters < 0) {
      editorTextCPs.splice(0, this.maxCharsNumber); // now editorTextCPs only contains the CPs of the overflow text
      const overflowLength = punycode.ucs2.encode(editorTextCPs).length;
      this.updateMark(editorText.length, overflowLength);
      this.$scope.isTooLong = true;
    } 
  }

  /**
   * Counts the number of remaining characters allowed, using twitter-text,
   * and updates the mark of extra chars if necessary
   */
  updateTwitterCharactersCountAndMark(editorText) {

    let textWithDMLink = editorText;
    if (this.$scope.addDMLink.isChecked) {
      // see https://business.twitter.com/en/help/campaign-editing-and-optimization/public-to-private-conversation.html
      // the link will be shortened and hence use 22 characters
      // we add it at the beginning so that it doesn't mess up with valid & display ranges end detection
      textWithDMLink = 'https://twitter.com/messages/compose?recipient_id=00000000 ' + editorText;
    }
    const parsed = twitterText.parseTweet(textWithDMLink);
    this.$scope.remainingCharacters = this.maxCharsNumber - parsed.weightedLength;
    if (parsed.validRangeEnd < parsed.displayRangeEnd) {
      this.updateMark(editorText.length, parsed.displayRangeEnd - parsed.validRangeEnd);
      this.$scope.isTooLong = true;
    } 
  }


  clearMark() {
    if (this.mark) {
      this.mark.clear();
    }
    this.mark = null;
  }
  
  /**
   * Updates the 'editor2-toolong' mark
   * As CodeMirror uses lineCh objects as coordinates for markText(),
   * we need to walk the lines in reverse order, until we have found
   * as many characters as the overflow 
   */
  updateMark(editorTextLength, overflowLength) {
    const doc = this.editor.getDoc();
    const endLineCh = doc.posFromIndex(editorTextLength);
    let startOfOverflowLineCh = angular.copy(endLineCh);
    let remainingOverflow = overflowLength;
    while (remainingOverflow > 0) {
      const currentLineText = doc.getLineHandle(startOfOverflowLineCh.line).text;
      if (currentLineText.length >= remainingOverflow) {
        startOfOverflowLineCh.ch = currentLineText.length - remainingOverflow;
        remainingOverflow = 0; 
      } else {
        startOfOverflowLineCh.line--;
        // we set a correct ch value for the corner case where remainingOverflow will be exactly 0 at the end of this iteration
        // (that will be the case if the first character of the overflow is a line break)
        startOfOverflowLineCh.ch = doc.getLineHandle(startOfOverflowLineCh.line).text.length;
        remainingOverflow -= currentLineText.length + 1; // + 1 for the line break
      }
    }
    this.mark = MarksHelper.createTooLongMark(this.editor, startOfOverflowLineCh, endLineCh);
  }


  updateCharactersCountAndMark() {
    this.clearMark();
    this.$scope.isTooLong = false; // will be set to true by one of the updateCharactersCount function if necessary
    const editorText = this.editor.getDoc().getValue();
    if (this.useTwitterTextLib) {
      this.updateTwitterCharactersCountAndMark(editorText);
    } else {
      this.updateNotTwitterCharactersCountAndMark(editorText);
    }
  }

}
